export class LabelsDto {
  static fromApi(data) {
    return {
      ...data,
      id: data.labelId,
      label: data.labelName,
    };
  }

  static fromApiArray(data) {
    return (Array.isArray(data) ? data : []).map(LabelsDto.fromApi);
  }

  static toApi({ labelData, userIds, fieldIds }) {
    return {
      labelName: labelData.label,
      labelValue: labelData.label,
      userIds: userIds,
      fieldIds: fieldIds,
      users: userIds,
      fields: fieldIds,
      color: labelData.color,
    };
  }

  static toApiResource(type, resourceId) {
    return {
      [type]: [resourceId],
    };
  }
}
